/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminMinuteEnrollmentBulkDecisionRequest,
  AdminMinuteEnrollmentBulkDecisionResponse,
  AdminMinuteEnrollmentDecisionRequest,
  AdminMinuteEnrollmentList,
  AdminMinuteEnrollmentMetrics,
  AdminMinuteEnrollmentResolveProIdsRequest,
  AdminMinuteEnrollmentResolveProIdsResponse,
  AdminMinuteProgramEnrollmentsApproveCreate400,
  AdminMinuteProgramEnrollmentsBulkApproveCreate400,
  AdminMinuteProgramEnrollmentsBulkDeclineCreate400,
  AdminMinuteProgramEnrollmentsDeclineCreate400,
  AdminMinuteProgramEnrollmentsExportCsvRetrieve400,
  AdminMinuteProgramEnrollmentsExportCsvRetrieveParams,
  AdminMinuteProgramEnrollmentsListParams,
  AdminMinuteProgramEnrollmentsResolveProIdsCreate400,
  AdminMinuteProgramEnrollmentsUnenrollCreate400,
  InterestQuestionnaire,
  InterestSubmission,
  InterestSubmitRequest,
  MinuteEnrollment,
  MinuteEnrollmentStartRequest,
  MinuteEnrollmentSubmitRequest,
  MinuteTrainingPortalAcceptTermsRequest,
  MinuteTrainingPortalState,
  NotFoundError,
  PaginatedAdminMinuteEnrollmentListList,
  PatchedMinuteShippingAddressRequest,
  PermissionDeniedError,
  TaskHoursUploadJobEnqueued,
  TaskHoursUploadJobStatus,
  TaskHoursUploadRequestRequest,
  UnauthenticatedError,
  ValidationError
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAdminMinuteProgramEnrollmentsListUrl = (params?: AdminMinuteProgramEnrollmentsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/minute-program/enrollments/?${stringifiedParams}` : `/api/admin/minute-program/enrollments/`
}

/**
 * Paginated list of pros, one row each: only a pro's **current** enrollment is listed, so a pro who re-applied appears once, in the state they are in now, rather than once per historical row. Superseded rows are not listed and this endpoint exposes no way to enumerate them; ``retrieve`` still returns one by id. **One exception:** ``?state=interest_submitted`` on its own is the review queue, which lists any pro holding a live ``interest_submitted`` row even when a newer row in another state has since become their current one. That tab asks who is awaiting review, not who a pro is today. Default order pushes ``started`` rows (``interest_submitted_at IS NULL``) to the end so the review queue leads with submitted rows.
 * @summary List MinuteEnrollment rows for the Task Ops admin portal.
 */
export const adminMinuteProgramEnrollmentsList = async (params?: AdminMinuteProgramEnrollmentsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedAdminMinuteEnrollmentListList> => {

  return customFetch<PaginatedAdminMinuteEnrollmentListList>(getAdminMinuteProgramEnrollmentsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMinuteProgramEnrollmentsListInfiniteQueryKey = (params?: AdminMinuteProgramEnrollmentsListParams,) => {
    return [
    'infinite', `/api/admin/minute-program/enrollments/`, ...(params ? [params] : [])
    ] as const;
    }

export const getAdminMinuteProgramEnrollmentsListQueryKey = (params?: AdminMinuteProgramEnrollmentsListParams,) => {
    return [
    `/api/admin/minute-program/enrollments/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminMinuteProgramEnrollmentsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, AdminMinuteProgramEnrollmentsListParams['page']>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(params?: AdminMinuteProgramEnrollmentsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError, TData, QueryKey, AdminMinuteProgramEnrollmentsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMinuteProgramEnrollmentsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, QueryKey, AdminMinuteProgramEnrollmentsListParams['page']> = ({ signal, pageParam }) => adminMinuteProgramEnrollmentsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError, TData, QueryKey, AdminMinuteProgramEnrollmentsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMinuteProgramEnrollmentsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>>
export type AdminMinuteProgramEnrollmentsListInfiniteQueryError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError


export function useAdminMinuteProgramEnrollmentsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, AdminMinuteProgramEnrollmentsListParams['page']>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params: undefined |  AdminMinuteProgramEnrollmentsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError, TData, QueryKey, AdminMinuteProgramEnrollmentsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>,
          TError,
          Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMinuteProgramEnrollmentsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, AdminMinuteProgramEnrollmentsListParams['page']>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: AdminMinuteProgramEnrollmentsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError, TData, QueryKey, AdminMinuteProgramEnrollmentsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>,
          TError,
          Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMinuteProgramEnrollmentsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, AdminMinuteProgramEnrollmentsListParams['page']>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: AdminMinuteProgramEnrollmentsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError, TData, QueryKey, AdminMinuteProgramEnrollmentsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List MinuteEnrollment rows for the Task Ops admin portal.
 */

export function useAdminMinuteProgramEnrollmentsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, AdminMinuteProgramEnrollmentsListParams['page']>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: AdminMinuteProgramEnrollmentsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError, TData, QueryKey, AdminMinuteProgramEnrollmentsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMinuteProgramEnrollmentsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMinuteProgramEnrollmentsListQueryOptions = <TData = Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(params?: AdminMinuteProgramEnrollmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMinuteProgramEnrollmentsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>> = ({ signal }) => adminMinuteProgramEnrollmentsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMinuteProgramEnrollmentsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>>
export type AdminMinuteProgramEnrollmentsListQueryError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError


export function useAdminMinuteProgramEnrollmentsList<TData = Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params: undefined |  AdminMinuteProgramEnrollmentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>,
          TError,
          Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMinuteProgramEnrollmentsList<TData = Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: AdminMinuteProgramEnrollmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>,
          TError,
          Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMinuteProgramEnrollmentsList<TData = Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: AdminMinuteProgramEnrollmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List MinuteEnrollment rows for the Task Ops admin portal.
 */

export function useAdminMinuteProgramEnrollmentsList<TData = Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: AdminMinuteProgramEnrollmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMinuteProgramEnrollmentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMinuteProgramEnrollmentsRetrieveUrl = (id: number,) => {




  return `/api/admin/minute-program/enrollments/${id}/`
}

/**
 * Same shape as the list rows. Retrieve is unscoped by state so a terminal-state enrollment (rejected / withdrawn / unenrolled) can still be inspected from the CRM, and unscoped by ``current`` so a superseded row a pro has since replaced is still reachable by id -- unlike ``list``, which shows only the current row.
 * @summary Retrieve a single MinuteEnrollment row for the admin portal.
 */
export const adminMinuteProgramEnrollmentsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<AdminMinuteEnrollmentList> => {

  return customFetch<AdminMinuteEnrollmentList>(getAdminMinuteProgramEnrollmentsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMinuteProgramEnrollmentsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/admin/minute-program/enrollments/${id}/`
    ] as const;
    }


export const getAdminMinuteProgramEnrollmentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMinuteProgramEnrollmentsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>> = ({ signal }) => adminMinuteProgramEnrollmentsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMinuteProgramEnrollmentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>>
export type AdminMinuteProgramEnrollmentsRetrieveQueryError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError


export function useAdminMinuteProgramEnrollmentsRetrieve<TData = Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMinuteProgramEnrollmentsRetrieve<TData = Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMinuteProgramEnrollmentsRetrieve<TData = Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve a single MinuteEnrollment row for the admin portal.
 */

export function useAdminMinuteProgramEnrollmentsRetrieve<TData = Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMinuteProgramEnrollmentsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMinuteProgramEnrollmentsApproveCreateUrl = (id: number,) => {




  return `/api/admin/minute-program/enrollments/${id}/approve/`
}

/**
 * Wraps ``MinuteEnrollment.approve()``. Holds a per-pro lock for the duration of the transition so a concurrent pro-side withdraw or another admin transition on the same row cannot be silently reverted.
 * @summary Approve a single MinuteEnrollment (interest_submitted -> approved).
 */
export const adminMinuteProgramEnrollmentsApproveCreate = async (id: number,
    adminMinuteEnrollmentDecisionRequest?: AdminMinuteEnrollmentDecisionRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminMinuteEnrollmentList> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminMinuteEnrollmentList>(getAdminMinuteProgramEnrollmentsApproveCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminMinuteEnrollmentDecisionRequest)
  }
);}





export const getAdminMinuteProgramEnrollmentsApproveCreateMutationKey = () => ['adminMinuteProgramEnrollmentsApproveCreate'] as const;

export const getAdminMinuteProgramEnrollmentsApproveCreateMutationOptions = <TError = AdminMinuteProgramEnrollmentsApproveCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsApproveCreate>>, TError,AdminMinuteProgramEnrollmentsApproveCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsApproveCreate>>, TError,AdminMinuteProgramEnrollmentsApproveCreateMutationVariables, TContext> => {

const mutationKey = getAdminMinuteProgramEnrollmentsApproveCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsApproveCreate>>, AdminMinuteProgramEnrollmentsApproveCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminMinuteProgramEnrollmentsApproveCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMinuteProgramEnrollmentsApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsApproveCreate>>>
    export type AdminMinuteProgramEnrollmentsApproveCreateMutationBody = AdminMinuteEnrollmentDecisionRequest | undefined
    export type AdminMinuteProgramEnrollmentsApproveCreateMutationError = AdminMinuteProgramEnrollmentsApproveCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError
    export type AdminMinuteProgramEnrollmentsApproveCreateMutationVariables = {id: number;data?: AdminMinuteEnrollmentDecisionRequest}

    /**
 * @summary Approve a single MinuteEnrollment (interest_submitted -> approved).
 */
export const useAdminMinuteProgramEnrollmentsApproveCreate = <TError = AdminMinuteProgramEnrollmentsApproveCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsApproveCreate>>, TError,AdminMinuteProgramEnrollmentsApproveCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsApproveCreate>>,
        TError,
        AdminMinuteProgramEnrollmentsApproveCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminMinuteProgramEnrollmentsApproveCreateMutationOptions(options), queryClient);
    }
    export const getAdminMinuteProgramEnrollmentsDeclineCreateUrl = (id: number,) => {




  return `/api/admin/minute-program/enrollments/${id}/decline/`
}

/**
 * Wraps ``MinuteEnrollment.reject()``. Same per-pro locking semantics as ``approve``.
 * @summary Decline a single MinuteEnrollment (interest_submitted -> rejected).
 */
export const adminMinuteProgramEnrollmentsDeclineCreate = async (id: number,
    adminMinuteEnrollmentDecisionRequest?: AdminMinuteEnrollmentDecisionRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminMinuteEnrollmentList> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminMinuteEnrollmentList>(getAdminMinuteProgramEnrollmentsDeclineCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminMinuteEnrollmentDecisionRequest)
  }
);}





export const getAdminMinuteProgramEnrollmentsDeclineCreateMutationKey = () => ['adminMinuteProgramEnrollmentsDeclineCreate'] as const;

export const getAdminMinuteProgramEnrollmentsDeclineCreateMutationOptions = <TError = AdminMinuteProgramEnrollmentsDeclineCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsDeclineCreate>>, TError,AdminMinuteProgramEnrollmentsDeclineCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsDeclineCreate>>, TError,AdminMinuteProgramEnrollmentsDeclineCreateMutationVariables, TContext> => {

const mutationKey = getAdminMinuteProgramEnrollmentsDeclineCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsDeclineCreate>>, AdminMinuteProgramEnrollmentsDeclineCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminMinuteProgramEnrollmentsDeclineCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMinuteProgramEnrollmentsDeclineCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsDeclineCreate>>>
    export type AdminMinuteProgramEnrollmentsDeclineCreateMutationBody = AdminMinuteEnrollmentDecisionRequest | undefined
    export type AdminMinuteProgramEnrollmentsDeclineCreateMutationError = AdminMinuteProgramEnrollmentsDeclineCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError
    export type AdminMinuteProgramEnrollmentsDeclineCreateMutationVariables = {id: number;data?: AdminMinuteEnrollmentDecisionRequest}

    /**
 * @summary Decline a single MinuteEnrollment (interest_submitted -> rejected).
 */
export const useAdminMinuteProgramEnrollmentsDeclineCreate = <TError = AdminMinuteProgramEnrollmentsDeclineCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsDeclineCreate>>, TError,AdminMinuteProgramEnrollmentsDeclineCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsDeclineCreate>>,
        TError,
        AdminMinuteProgramEnrollmentsDeclineCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminMinuteProgramEnrollmentsDeclineCreateMutationOptions(options), queryClient);
    }
    export const getAdminMinuteProgramEnrollmentsUnenrollCreateUrl = (id: number,) => {




  return `/api/admin/minute-program/enrollments/${id}/unenroll/`
}

/**
 * Move an enrollment ``approved`` or ``active`` -> ``unenrolled``. UI-facing this is "Disable". The model rejects transitions from any other state, and that rejection surfaces here as a 400. Rejects a non-empty request body: the model method takes no audit fields, so accepting a payload would silently drop it.
 * @summary Unenroll (a.k.a. Disable) a MinuteEnrollment.
 */
export const adminMinuteProgramEnrollmentsUnenrollCreate = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<AdminMinuteEnrollmentList> => {

  return customFetch<AdminMinuteEnrollmentList>(getAdminMinuteProgramEnrollmentsUnenrollCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminMinuteProgramEnrollmentsUnenrollCreateMutationKey = () => ['adminMinuteProgramEnrollmentsUnenrollCreate'] as const;

export const getAdminMinuteProgramEnrollmentsUnenrollCreateMutationOptions = <TError = AdminMinuteProgramEnrollmentsUnenrollCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsUnenrollCreate>>, TError,AdminMinuteProgramEnrollmentsUnenrollCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsUnenrollCreate>>, TError,AdminMinuteProgramEnrollmentsUnenrollCreateMutationVariables, TContext> => {

const mutationKey = getAdminMinuteProgramEnrollmentsUnenrollCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsUnenrollCreate>>, AdminMinuteProgramEnrollmentsUnenrollCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  adminMinuteProgramEnrollmentsUnenrollCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMinuteProgramEnrollmentsUnenrollCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsUnenrollCreate>>>

    export type AdminMinuteProgramEnrollmentsUnenrollCreateMutationError = AdminMinuteProgramEnrollmentsUnenrollCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError
    export type AdminMinuteProgramEnrollmentsUnenrollCreateMutationVariables = {id: number}

    /**
 * @summary Unenroll (a.k.a. Disable) a MinuteEnrollment.
 */
export const useAdminMinuteProgramEnrollmentsUnenrollCreate = <TError = AdminMinuteProgramEnrollmentsUnenrollCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsUnenrollCreate>>, TError,AdminMinuteProgramEnrollmentsUnenrollCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsUnenrollCreate>>,
        TError,
        AdminMinuteProgramEnrollmentsUnenrollCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminMinuteProgramEnrollmentsUnenrollCreateMutationOptions(options), queryClient);
    }
    export const getAdminMinuteProgramEnrollmentsBulkApproveCreateUrl = () => {




  return `/api/admin/minute-program/enrollments/bulk-approve/`
}

/**
 * Fan out the approve transition over a batch (max 500). All-or-nothing: an unknown id or a row not in ``interest_submitted`` rejects the whole request before any write. All pros involved get their user row locked before the transition to serialise against concurrent pro-side actions.
 * @summary Bulk approve MinuteEnrollment rows.
 */
export const adminMinuteProgramEnrollmentsBulkApproveCreate = async (adminMinuteEnrollmentBulkDecisionRequest: AdminMinuteEnrollmentBulkDecisionRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminMinuteEnrollmentBulkDecisionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminMinuteEnrollmentBulkDecisionResponse>(getAdminMinuteProgramEnrollmentsBulkApproveCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminMinuteEnrollmentBulkDecisionRequest)
  }
);}





export const getAdminMinuteProgramEnrollmentsBulkApproveCreateMutationKey = () => ['adminMinuteProgramEnrollmentsBulkApproveCreate'] as const;

export const getAdminMinuteProgramEnrollmentsBulkApproveCreateMutationOptions = <TError = AdminMinuteProgramEnrollmentsBulkApproveCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsBulkApproveCreate>>, TError,AdminMinuteProgramEnrollmentsBulkApproveCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsBulkApproveCreate>>, TError,AdminMinuteProgramEnrollmentsBulkApproveCreateMutationVariables, TContext> => {

const mutationKey = getAdminMinuteProgramEnrollmentsBulkApproveCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsBulkApproveCreate>>, AdminMinuteProgramEnrollmentsBulkApproveCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminMinuteProgramEnrollmentsBulkApproveCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMinuteProgramEnrollmentsBulkApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsBulkApproveCreate>>>
    export type AdminMinuteProgramEnrollmentsBulkApproveCreateMutationBody = AdminMinuteEnrollmentBulkDecisionRequest
    export type AdminMinuteProgramEnrollmentsBulkApproveCreateMutationError = AdminMinuteProgramEnrollmentsBulkApproveCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError
    export type AdminMinuteProgramEnrollmentsBulkApproveCreateMutationVariables = {data: AdminMinuteEnrollmentBulkDecisionRequest}

    /**
 * @summary Bulk approve MinuteEnrollment rows.
 */
export const useAdminMinuteProgramEnrollmentsBulkApproveCreate = <TError = AdminMinuteProgramEnrollmentsBulkApproveCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsBulkApproveCreate>>, TError,AdminMinuteProgramEnrollmentsBulkApproveCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsBulkApproveCreate>>,
        TError,
        AdminMinuteProgramEnrollmentsBulkApproveCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminMinuteProgramEnrollmentsBulkApproveCreateMutationOptions(options), queryClient);
    }
    export const getAdminMinuteProgramEnrollmentsBulkDeclineCreateUrl = () => {




  return `/api/admin/minute-program/enrollments/bulk-decline/`
}

/**
 * Fan out the decline transition over a batch (max 500). All-or-nothing precheck and per-pro locking mirror ``bulk-approve``.
 * @summary Bulk decline MinuteEnrollment rows.
 */
export const adminMinuteProgramEnrollmentsBulkDeclineCreate = async (adminMinuteEnrollmentBulkDecisionRequest: AdminMinuteEnrollmentBulkDecisionRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminMinuteEnrollmentBulkDecisionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminMinuteEnrollmentBulkDecisionResponse>(getAdminMinuteProgramEnrollmentsBulkDeclineCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminMinuteEnrollmentBulkDecisionRequest)
  }
);}





export const getAdminMinuteProgramEnrollmentsBulkDeclineCreateMutationKey = () => ['adminMinuteProgramEnrollmentsBulkDeclineCreate'] as const;

export const getAdminMinuteProgramEnrollmentsBulkDeclineCreateMutationOptions = <TError = AdminMinuteProgramEnrollmentsBulkDeclineCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsBulkDeclineCreate>>, TError,AdminMinuteProgramEnrollmentsBulkDeclineCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsBulkDeclineCreate>>, TError,AdminMinuteProgramEnrollmentsBulkDeclineCreateMutationVariables, TContext> => {

const mutationKey = getAdminMinuteProgramEnrollmentsBulkDeclineCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsBulkDeclineCreate>>, AdminMinuteProgramEnrollmentsBulkDeclineCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminMinuteProgramEnrollmentsBulkDeclineCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMinuteProgramEnrollmentsBulkDeclineCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsBulkDeclineCreate>>>
    export type AdminMinuteProgramEnrollmentsBulkDeclineCreateMutationBody = AdminMinuteEnrollmentBulkDecisionRequest
    export type AdminMinuteProgramEnrollmentsBulkDeclineCreateMutationError = AdminMinuteProgramEnrollmentsBulkDeclineCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError
    export type AdminMinuteProgramEnrollmentsBulkDeclineCreateMutationVariables = {data: AdminMinuteEnrollmentBulkDecisionRequest}

    /**
 * @summary Bulk decline MinuteEnrollment rows.
 */
export const useAdminMinuteProgramEnrollmentsBulkDeclineCreate = <TError = AdminMinuteProgramEnrollmentsBulkDeclineCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsBulkDeclineCreate>>, TError,AdminMinuteProgramEnrollmentsBulkDeclineCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsBulkDeclineCreate>>,
        TError,
        AdminMinuteProgramEnrollmentsBulkDeclineCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminMinuteProgramEnrollmentsBulkDeclineCreateMutationOptions(options), queryClient);
    }
    export const getAdminMinuteProgramEnrollmentsExportCsvRetrieveUrl = (params?: AdminMinuteProgramEnrollmentsExportCsvRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/minute-program/enrollments/export.csv/?${stringifiedParams}` : `/api/admin/minute-program/enrollments/export.csv/`
}

/**
 * Stream enrollments matching the same filters as ``list`` as CSV, and scoped to ``current`` exactly as ``list`` is -- including the review-queue exception. Honours ``?ordering=`` the same way ``list`` does; default sort is submitted-first with ``started`` rows pushed to the end. Columns: id, state, pro name, email, market, interest_submitted_at, approved_at, unenrolled_at. Streams via ``StreamingHttpResponse`` so a broad window never buffers the full result set.
 * @summary Stream enrollments matching filters as CSV.
 */
export const adminMinuteProgramEnrollmentsExportCsvRetrieve = async (params?: AdminMinuteProgramEnrollmentsExportCsvRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<string> => {

  return customFetch<string>(getAdminMinuteProgramEnrollmentsExportCsvRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMinuteProgramEnrollmentsExportCsvRetrieveQueryKey = (params?: AdminMinuteProgramEnrollmentsExportCsvRetrieveParams,) => {
    return [
    `/api/admin/minute-program/enrollments/export.csv/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminMinuteProgramEnrollmentsExportCsvRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>, TError = AdminMinuteProgramEnrollmentsExportCsvRetrieve400 | UnauthenticatedError | PermissionDeniedError | NotFoundError>(params?: AdminMinuteProgramEnrollmentsExportCsvRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMinuteProgramEnrollmentsExportCsvRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>> = ({ signal }) => adminMinuteProgramEnrollmentsExportCsvRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMinuteProgramEnrollmentsExportCsvRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>>
export type AdminMinuteProgramEnrollmentsExportCsvRetrieveQueryError = AdminMinuteProgramEnrollmentsExportCsvRetrieve400 | UnauthenticatedError | PermissionDeniedError | NotFoundError


export function useAdminMinuteProgramEnrollmentsExportCsvRetrieve<TData = Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>, TError = AdminMinuteProgramEnrollmentsExportCsvRetrieve400 | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params: undefined |  AdminMinuteProgramEnrollmentsExportCsvRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMinuteProgramEnrollmentsExportCsvRetrieve<TData = Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>, TError = AdminMinuteProgramEnrollmentsExportCsvRetrieve400 | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: AdminMinuteProgramEnrollmentsExportCsvRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMinuteProgramEnrollmentsExportCsvRetrieve<TData = Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>, TError = AdminMinuteProgramEnrollmentsExportCsvRetrieve400 | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: AdminMinuteProgramEnrollmentsExportCsvRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stream enrollments matching filters as CSV.
 */

export function useAdminMinuteProgramEnrollmentsExportCsvRetrieve<TData = Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>, TError = AdminMinuteProgramEnrollmentsExportCsvRetrieve400 | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 params?: AdminMinuteProgramEnrollmentsExportCsvRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsExportCsvRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMinuteProgramEnrollmentsExportCsvRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminMinuteProgramEnrollmentsResolveProIdsCreateUrl = () => {




  return `/api/admin/minute-program/enrollments/resolve-pro-ids/`
}

/**
 * Takes a list of pro (user) ids and returns the enrollment ids the Interested Users tab should select, plus a bucket per reason an id could not be selected. POST rather than GET because the id list routinely outgrows a safe query string; the action does not write.
 * @summary Resolve pro ids to their interest_submitted enrollments.
 */
export const adminMinuteProgramEnrollmentsResolveProIdsCreate = async (adminMinuteEnrollmentResolveProIdsRequest: AdminMinuteEnrollmentResolveProIdsRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdminMinuteEnrollmentResolveProIdsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AdminMinuteEnrollmentResolveProIdsResponse>(getAdminMinuteProgramEnrollmentsResolveProIdsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminMinuteEnrollmentResolveProIdsRequest)
  }
);}





export const getAdminMinuteProgramEnrollmentsResolveProIdsCreateMutationKey = () => ['adminMinuteProgramEnrollmentsResolveProIdsCreate'] as const;

export const getAdminMinuteProgramEnrollmentsResolveProIdsCreateMutationOptions = <TError = AdminMinuteProgramEnrollmentsResolveProIdsCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsResolveProIdsCreate>>, TError,AdminMinuteProgramEnrollmentsResolveProIdsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsResolveProIdsCreate>>, TError,AdminMinuteProgramEnrollmentsResolveProIdsCreateMutationVariables, TContext> => {

const mutationKey = getAdminMinuteProgramEnrollmentsResolveProIdsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsResolveProIdsCreate>>, AdminMinuteProgramEnrollmentsResolveProIdsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminMinuteProgramEnrollmentsResolveProIdsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminMinuteProgramEnrollmentsResolveProIdsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsResolveProIdsCreate>>>
    export type AdminMinuteProgramEnrollmentsResolveProIdsCreateMutationBody = AdminMinuteEnrollmentResolveProIdsRequest
    export type AdminMinuteProgramEnrollmentsResolveProIdsCreateMutationError = AdminMinuteProgramEnrollmentsResolveProIdsCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError
    export type AdminMinuteProgramEnrollmentsResolveProIdsCreateMutationVariables = {data: AdminMinuteEnrollmentResolveProIdsRequest}

    /**
 * @summary Resolve pro ids to their interest_submitted enrollments.
 */
export const useAdminMinuteProgramEnrollmentsResolveProIdsCreate = <TError = AdminMinuteProgramEnrollmentsResolveProIdsCreate400 | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsResolveProIdsCreate>>, TError,AdminMinuteProgramEnrollmentsResolveProIdsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminMinuteProgramEnrollmentsResolveProIdsCreate>>,
        TError,
        AdminMinuteProgramEnrollmentsResolveProIdsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminMinuteProgramEnrollmentsResolveProIdsCreateMutationOptions(options), queryClient);
    }
    export const getAdminMinuteProgramMetricsRetrieveUrl = () => {




  return `/api/admin/minute-program/metrics`
}

/**
 * Funnel counts for the Task Ops dashboard. Derived from existing timestamp columns only -- no reason breakdown, since the model has no reason field. Every stage reports its "this week" delta (rows whose driving timestamp lands in the last seven days).
 * @summary MinuteEnrollment funnel counts + this-week deltas.
 */
export const adminMinuteProgramMetricsRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminMinuteEnrollmentMetrics> => {

  return customFetch<AdminMinuteEnrollmentMetrics>(getAdminMinuteProgramMetricsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMinuteProgramMetricsRetrieveQueryKey = () => {
    return [
    `/api/admin/minute-program/metrics`
    ] as const;
    }


export const getAdminMinuteProgramMetricsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMinuteProgramMetricsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>> = ({ signal }) => adminMinuteProgramMetricsRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMinuteProgramMetricsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>>
export type AdminMinuteProgramMetricsRetrieveQueryError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError


export function useAdminMinuteProgramMetricsRetrieve<TData = Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMinuteProgramMetricsRetrieve<TData = Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMinuteProgramMetricsRetrieve<TData = Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary MinuteEnrollment funnel counts + this-week deltas.
 */

export function useAdminMinuteProgramMetricsRetrieve<TData = Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMinuteProgramMetricsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMinuteProgramMetricsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminTaskUploadsCreateUrl = () => {




  return `/api/admin/task/uploads`
}

/**
 * Runs header validation and the Cloudinary upload synchronously (both are cheap, and admins want fail-fast on a malformed header). Persists the CSV bytes + form fields onto a ``TaskHoursUploadJob`` row and returns 202 with the job id. Ingestion runs off the request path so the endpoint can't be killed by the gunicorn worker timeout. Poll ``GET /api/admin/task/uploads/jobs/<uuid>`` for the terminal summary.
 * @summary Enqueue a task hours CSV for async ingestion
 */
export const adminTaskUploadsCreate = async (taskHoursUploadRequestRequest: TaskHoursUploadRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<TaskHoursUploadJobEnqueued> => {
    const formData = new FormData();
formData.append(`file`, taskHoursUploadRequestRequest.file);
formData.append(`pay_period_start_date`, taskHoursUploadRequestRequest.pay_period_start_date);
formData.append(`pay_period_end_date`, taskHoursUploadRequestRequest.pay_period_end_date);

  return customFetch<TaskHoursUploadJobEnqueued>(getAdminTaskUploadsCreateUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getAdminTaskUploadsCreateMutationKey = () => ['adminTaskUploadsCreate'] as const;

export const getAdminTaskUploadsCreateMutationOptions = <TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTaskUploadsCreate>>, TError,AdminTaskUploadsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminTaskUploadsCreate>>, TError,AdminTaskUploadsCreateMutationVariables, TContext> => {

const mutationKey = getAdminTaskUploadsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminTaskUploadsCreate>>, AdminTaskUploadsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminTaskUploadsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminTaskUploadsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminTaskUploadsCreate>>>
    export type AdminTaskUploadsCreateMutationBody = TaskHoursUploadRequestRequest
    export type AdminTaskUploadsCreateMutationError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError
    export type AdminTaskUploadsCreateMutationVariables = {data: TaskHoursUploadRequestRequest}

    /**
 * @summary Enqueue a task hours CSV for async ingestion
 */
export const useAdminTaskUploadsCreate = <TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTaskUploadsCreate>>, TError,AdminTaskUploadsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminTaskUploadsCreate>>,
        TError,
        AdminTaskUploadsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminTaskUploadsCreateMutationOptions(options), queryClient);
    }
    export const getAdminTaskUploadsJobsRetrieveUrl = (jobId: string,) => {




  return `/api/admin/task/uploads/jobs/${jobId}`
}

/**
 * Returns the current status, the accepted / skipped / rejected counters (populated once the worker finishes), and ``error_message`` (populated only when ``status == failed``). 404 on an unknown job id.
 * @summary Fetch the status of an async task hours upload job
 */
export const adminTaskUploadsJobsRetrieve = async (jobId: string, options?: Parameters<typeof customFetch>[1]): Promise<TaskHoursUploadJobStatus> => {

  return customFetch<TaskHoursUploadJobStatus>(getAdminTaskUploadsJobsRetrieveUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminTaskUploadsJobsRetrieveQueryKey = (jobId: string,) => {
    return [
    `/api/admin/task/uploads/jobs/${jobId}`
    ] as const;
    }


export const getAdminTaskUploadsJobsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminTaskUploadsJobsRetrieveQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>> = ({ signal }) => adminTaskUploadsJobsRetrieve(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminTaskUploadsJobsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>>
export type AdminTaskUploadsJobsRetrieveQueryError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError


export function useAdminTaskUploadsJobsRetrieve<TData = Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTaskUploadsJobsRetrieve<TData = Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTaskUploadsJobsRetrieve<TData = Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch the status of an async task hours upload job
 */

export function useAdminTaskUploadsJobsRetrieve<TData = Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTaskUploadsJobsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminTaskUploadsJobsRetrieveQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMinuteEnrollmentRetrieveUrl = () => {




  return `/api/minute/enrollment`
}

/**
 * Returns the pro's most-recent ``MinuteEnrollment`` row regardless of state, or 404 if the pro has never submitted interest.
 * @summary Get the pro's current Minute enrollment
 */
export const minuteEnrollmentRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<MinuteEnrollment> => {

  return customFetch<MinuteEnrollment>(getMinuteEnrollmentRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMinuteEnrollmentRetrieveQueryKey = () => {
    return [
    `/api/minute/enrollment`
    ] as const;
    }


export const getMinuteEnrollmentRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMinuteEnrollmentRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>> = ({ signal }) => minuteEnrollmentRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MinuteEnrollmentRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>>
export type MinuteEnrollmentRetrieveQueryError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError


export function useMinuteEnrollmentRetrieve<TData = Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMinuteEnrollmentRetrieve<TData = Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMinuteEnrollmentRetrieve<TData = Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the pro's current Minute enrollment
 */

export function useMinuteEnrollmentRetrieve<TData = Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof minuteEnrollmentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMinuteEnrollmentRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMinuteEnrollmentCreateUrl = () => {




  return `/api/minute/enrollment`
}

/**
 * Moves the pro to ``interest_submitted``, advancing an existing ``started`` row or creating one outright. Returns 409 if the pro already has a non-terminal enrollment past ``started``. Eligibility is only checked for a pro who has a ``started`` row (i.e. who entered via the at-home funnel), which then yields 403 if that row's ZIP is no longer eligible; a pro without one is not ZIP-gated.
 * @summary Submit Minute enrollment interest
 */
export const minuteEnrollmentCreate = async (minuteEnrollmentSubmitRequest: MinuteEnrollmentSubmitRequest, options?: Parameters<typeof customFetch>[1]): Promise<MinuteEnrollment> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<MinuteEnrollment>(getMinuteEnrollmentCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(minuteEnrollmentSubmitRequest)
  }
);}





export const getMinuteEnrollmentCreateMutationKey = () => ['minuteEnrollmentCreate'] as const;

export const getMinuteEnrollmentCreateMutationOptions = <TError = ValidationError | UnauthenticatedError | void | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof minuteEnrollmentCreate>>, TError,MinuteEnrollmentCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof minuteEnrollmentCreate>>, TError,MinuteEnrollmentCreateMutationVariables, TContext> => {

const mutationKey = getMinuteEnrollmentCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof minuteEnrollmentCreate>>, MinuteEnrollmentCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  minuteEnrollmentCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MinuteEnrollmentCreateMutationResult = NonNullable<Awaited<ReturnType<typeof minuteEnrollmentCreate>>>
    export type MinuteEnrollmentCreateMutationBody = MinuteEnrollmentSubmitRequest
    export type MinuteEnrollmentCreateMutationError = ValidationError | UnauthenticatedError | void | NotFoundError
    export type MinuteEnrollmentCreateMutationVariables = {data: MinuteEnrollmentSubmitRequest}

    /**
 * @summary Submit Minute enrollment interest
 */
export const useMinuteEnrollmentCreate = <TError = ValidationError | UnauthenticatedError | void | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof minuteEnrollmentCreate>>, TError,MinuteEnrollmentCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof minuteEnrollmentCreate>>,
        TError,
        MinuteEnrollmentCreateMutationVariables,
        TContext
      > => {
      return useMutation(getMinuteEnrollmentCreateMutationOptions(options), queryClient);
    }
    export const getMinuteEnrollmentPartialUpdateUrl = () => {




  return `/api/minute/enrollment`
}

/**
 * Writes the address onto the pro's open enrollment row only. The gigster profile is not touched: its address, the insurance-onboarding step and the Stripe account are left exactly as they were.
 *
 * Requires an open enrollment: 409 when the pro has none, since there is nothing to ship and the columns would otherwise be written onto a withdrawn row.
 * @summary Set the ship-to address for the pro's Minute headset
 */
export const minuteEnrollmentPartialUpdate = async (patchedMinuteShippingAddressRequest?: PatchedMinuteShippingAddressRequest, options?: Parameters<typeof customFetch>[1]): Promise<MinuteEnrollment> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<MinuteEnrollment>(getMinuteEnrollmentPartialUpdateUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedMinuteShippingAddressRequest)
  }
);}





export const getMinuteEnrollmentPartialUpdateMutationKey = () => ['minuteEnrollmentPartialUpdate'] as const;

export const getMinuteEnrollmentPartialUpdateMutationOptions = <TError = void | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof minuteEnrollmentPartialUpdate>>, TError,MinuteEnrollmentPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof minuteEnrollmentPartialUpdate>>, TError,MinuteEnrollmentPartialUpdateMutationVariables, TContext> => {

const mutationKey = getMinuteEnrollmentPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof minuteEnrollmentPartialUpdate>>, MinuteEnrollmentPartialUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  minuteEnrollmentPartialUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MinuteEnrollmentPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof minuteEnrollmentPartialUpdate>>>
    export type MinuteEnrollmentPartialUpdateMutationBody = PatchedMinuteShippingAddressRequest | undefined
    export type MinuteEnrollmentPartialUpdateMutationError = void | UnauthenticatedError | PermissionDeniedError | NotFoundError
    export type MinuteEnrollmentPartialUpdateMutationVariables = {data?: PatchedMinuteShippingAddressRequest}

    /**
 * @summary Set the ship-to address for the pro's Minute headset
 */
export const useMinuteEnrollmentPartialUpdate = <TError = void | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof minuteEnrollmentPartialUpdate>>, TError,MinuteEnrollmentPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof minuteEnrollmentPartialUpdate>>,
        TError,
        MinuteEnrollmentPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getMinuteEnrollmentPartialUpdateMutationOptions(options), queryClient);
    }
    export const getMinuteEnrollmentDestroyUrl = () => {




  return `/api/minute/enrollment`
}

/**
 * Withdraws a ``started`` or ``interest_submitted`` row, or unenrolls an ``approved`` row. Withdrawing a ``started`` row is how a pro recovers from a stored ZIP that left the whitelist. Returns 404 if the pro has no current row (or only terminal history).
 * @summary Withdraw or unenroll from the Minute program
 */
export const minuteEnrollmentDestroy = async ( options?: Parameters<typeof customFetch>[1]): Promise<MinuteEnrollment> => {

  return customFetch<MinuteEnrollment>(getMinuteEnrollmentDestroyUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMinuteEnrollmentDestroyMutationKey = () => ['minuteEnrollmentDestroy'] as const;

export const getMinuteEnrollmentDestroyMutationOptions = <TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof minuteEnrollmentDestroy>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof minuteEnrollmentDestroy>>, TError,void, TContext> => {

const mutationKey = getMinuteEnrollmentDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof minuteEnrollmentDestroy>>, void> = () => {


          return  minuteEnrollmentDestroy(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MinuteEnrollmentDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof minuteEnrollmentDestroy>>>

    export type MinuteEnrollmentDestroyMutationError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError


    /**
 * @summary Withdraw or unenroll from the Minute program
 */
export const useMinuteEnrollmentDestroy = <TError = ValidationError | UnauthenticatedError | PermissionDeniedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof minuteEnrollmentDestroy>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof minuteEnrollmentDestroy>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMinuteEnrollmentDestroyMutationOptions(options), queryClient);
    }
    export const getMinuteEnrollmentStartCreateUrl = () => {




  return `/api/minute/enrollment/start`
}

/**
 * Validates ``postal_code`` against the at-home ZIP whitelist and market capability, then creates the pro's ``started`` enrollment carrying that ZIP. 201 on create; 200 with the existing row when the pro is already ``started`` (the originally-admitted ZIP is kept, so a different ``postal_code`` here does not move the row); 409 when the pro has an open enrollment past ``started``. The whitelist is not returned as a list, but it is not secret: the public ZIP lookup answers eligible/not-eligible per ZIP.
 *
 * 403 covers both an ineligible ``postal_code`` on the create path and an existing ``started`` row whose stored ZIP is no longer eligible — the whitelist can shrink under a half-finished signup. ``GET /minute/enrollment`` distinguishes them: a ``started`` row means the stored ZIP went stale, and the pro recovers with ``DELETE /minute/enrollment`` followed by starting again. No row means the submitted ZIP is simply not eligible. An eligible ``started`` row is never 403ed for the ZIP in *this* request, so that recovery can never discard a valid enrollment.
 * @summary Start an at-home (Figure/Minute) enrollment
 */
export const minuteEnrollmentStartCreate = async (minuteEnrollmentStartRequest: MinuteEnrollmentStartRequest, options?: Parameters<typeof customFetch>[1]): Promise<MinuteEnrollment> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<MinuteEnrollment>(getMinuteEnrollmentStartCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(minuteEnrollmentStartRequest)
  }
);}





export const getMinuteEnrollmentStartCreateMutationKey = () => ['minuteEnrollmentStartCreate'] as const;

export const getMinuteEnrollmentStartCreateMutationOptions = <TError = void | UnauthenticatedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof minuteEnrollmentStartCreate>>, TError,MinuteEnrollmentStartCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof minuteEnrollmentStartCreate>>, TError,MinuteEnrollmentStartCreateMutationVariables, TContext> => {

const mutationKey = getMinuteEnrollmentStartCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof minuteEnrollmentStartCreate>>, MinuteEnrollmentStartCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  minuteEnrollmentStartCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MinuteEnrollmentStartCreateMutationResult = NonNullable<Awaited<ReturnType<typeof minuteEnrollmentStartCreate>>>
    export type MinuteEnrollmentStartCreateMutationBody = MinuteEnrollmentStartRequest
    export type MinuteEnrollmentStartCreateMutationError = void | UnauthenticatedError | NotFoundError
    export type MinuteEnrollmentStartCreateMutationVariables = {data: MinuteEnrollmentStartRequest}

    /**
 * @summary Start an at-home (Figure/Minute) enrollment
 */
export const useMinuteEnrollmentStartCreate = <TError = void | UnauthenticatedError | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof minuteEnrollmentStartCreate>>, TError,MinuteEnrollmentStartCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof minuteEnrollmentStartCreate>>,
        TError,
        MinuteEnrollmentStartCreateMutationVariables,
        TContext
      > => {
      return useMutation(getMinuteEnrollmentStartCreateMutationOptions(options), queryClient);
    }
    export const getMinuteInterestCreateUrl = () => {




  return `/api/minute/interest`
}

/**
 * Validates answers against the pinned questionnaire version, records the submission, and moves the enrollment to ``interest_submitted`` — advancing the ``started`` row from ``POST /minute/enrollment/start`` when there is one. Returns 409 when the pro already has an open enrollment past ``started``. Eligibility is only checked for a pro who has a ``started`` row, which then yields 403 if that row's ZIP is no longer eligible; a pro without one is not ZIP-gated.
 * @summary Submit Minute interest questionnaire answers
 */
export const minuteInterestCreate = async (interestSubmitRequest: InterestSubmitRequest, options?: Parameters<typeof customFetch>[1]): Promise<InterestSubmission> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<InterestSubmission>(getMinuteInterestCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(interestSubmitRequest)
  }
);}





export const getMinuteInterestCreateMutationKey = () => ['minuteInterestCreate'] as const;

export const getMinuteInterestCreateMutationOptions = <TError = void | UnauthenticatedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof minuteInterestCreate>>, TError,MinuteInterestCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof minuteInterestCreate>>, TError,MinuteInterestCreateMutationVariables, TContext> => {

const mutationKey = getMinuteInterestCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof minuteInterestCreate>>, MinuteInterestCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  minuteInterestCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MinuteInterestCreateMutationResult = NonNullable<Awaited<ReturnType<typeof minuteInterestCreate>>>
    export type MinuteInterestCreateMutationBody = InterestSubmitRequest
    export type MinuteInterestCreateMutationError = void | UnauthenticatedError
    export type MinuteInterestCreateMutationVariables = {data: InterestSubmitRequest}

    /**
 * @summary Submit Minute interest questionnaire answers
 */
export const useMinuteInterestCreate = <TError = void | UnauthenticatedError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof minuteInterestCreate>>, TError,MinuteInterestCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof minuteInterestCreate>>,
        TError,
        MinuteInterestCreateMutationVariables,
        TContext
      > => {
      return useMutation(getMinuteInterestCreateMutationOptions(options), queryClient);
    }
    export const getMinuteInterestQuestionnaireRetrieveUrl = () => {




  return `/api/minute/interest-questionnaire`
}

/**
 * Returns the active question set for the Figure/Minute interest form. 404 when no version is active, which the client should treat as "interest is not open" rather than an error.
 * @summary Get the active Minute interest questionnaire
 */
export const minuteInterestQuestionnaireRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<InterestQuestionnaire> => {

  return customFetch<InterestQuestionnaire>(getMinuteInterestQuestionnaireRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMinuteInterestQuestionnaireRetrieveQueryKey = () => {
    return [
    `/api/minute/interest-questionnaire`
    ] as const;
    }


export const getMinuteInterestQuestionnaireRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMinuteInterestQuestionnaireRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>> = ({ signal }) => minuteInterestQuestionnaireRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MinuteInterestQuestionnaireRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>>
export type MinuteInterestQuestionnaireRetrieveQueryError = ValidationError | UnauthenticatedError | PermissionDeniedError | void


export function useMinuteInterestQuestionnaireRetrieve<TData = Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>,
          TError,
          Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMinuteInterestQuestionnaireRetrieve<TData = Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>,
          TError,
          Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMinuteInterestQuestionnaireRetrieve<TData = Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the active Minute interest questionnaire
 */

export function useMinuteInterestQuestionnaireRetrieve<TData = Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof minuteInterestQuestionnaireRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMinuteInterestQuestionnaireRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMinuteTrainingPortalRetrieveUrl = () => {




  return `/api/minute/training-portal`
}

/**
 * Returns the training-portal unlock state (``locked`` before terms acceptance, ``active`` after). 404 when the pro has no current ``approved`` enrollment.
 * @summary Get the pro's Minute training-portal state
 */
export const minuteTrainingPortalRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<MinuteTrainingPortalState> => {

  return customFetch<MinuteTrainingPortalState>(getMinuteTrainingPortalRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMinuteTrainingPortalRetrieveQueryKey = () => {
    return [
    `/api/minute/training-portal`
    ] as const;
    }


export const getMinuteTrainingPortalRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMinuteTrainingPortalRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>> = ({ signal }) => minuteTrainingPortalRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MinuteTrainingPortalRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>>
export type MinuteTrainingPortalRetrieveQueryError = ValidationError | UnauthenticatedError | PermissionDeniedError | void


export function useMinuteTrainingPortalRetrieve<TData = Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>,
          TError,
          Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMinuteTrainingPortalRetrieve<TData = Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>,
          TError,
          Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMinuteTrainingPortalRetrieve<TData = Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the pro's Minute training-portal state
 */

export function useMinuteTrainingPortalRetrieve<TData = Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>, TError = ValidationError | UnauthenticatedError | PermissionDeniedError | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof minuteTrainingPortalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMinuteTrainingPortalRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMinuteTrainingPortalAcceptTermsCreateUrl = () => {




  return `/api/minute/training-portal/accept-terms`
}

/**
 * Records the pro's acceptance of the training-portal terms (``terms_version`` is a positive integer identifying the terms body -- e.g. ``1``). Idempotent, first-write wins: any subsequent POST is a no-op that preserves the originally-accepted timestamp and version, regardless of the incoming value. Returns 404 when the pro has no current ``approved`` enrollment.
 * @summary Accept the Minute training-portal terms
 */
export const minuteTrainingPortalAcceptTermsCreate = async (minuteTrainingPortalAcceptTermsRequest: MinuteTrainingPortalAcceptTermsRequest, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<void>(getMinuteTrainingPortalAcceptTermsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(minuteTrainingPortalAcceptTermsRequest)
  }
);}





export const getMinuteTrainingPortalAcceptTermsCreateMutationKey = () => ['minuteTrainingPortalAcceptTermsCreate'] as const;

export const getMinuteTrainingPortalAcceptTermsCreateMutationOptions = <TError = ValidationError | UnauthenticatedError | PermissionDeniedError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof minuteTrainingPortalAcceptTermsCreate>>, TError,MinuteTrainingPortalAcceptTermsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof minuteTrainingPortalAcceptTermsCreate>>, TError,MinuteTrainingPortalAcceptTermsCreateMutationVariables, TContext> => {

const mutationKey = getMinuteTrainingPortalAcceptTermsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof minuteTrainingPortalAcceptTermsCreate>>, MinuteTrainingPortalAcceptTermsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  minuteTrainingPortalAcceptTermsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MinuteTrainingPortalAcceptTermsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof minuteTrainingPortalAcceptTermsCreate>>>
    export type MinuteTrainingPortalAcceptTermsCreateMutationBody = MinuteTrainingPortalAcceptTermsRequest
    export type MinuteTrainingPortalAcceptTermsCreateMutationError = ValidationError | UnauthenticatedError | PermissionDeniedError | void
    export type MinuteTrainingPortalAcceptTermsCreateMutationVariables = {data: MinuteTrainingPortalAcceptTermsRequest}

    /**
 * @summary Accept the Minute training-portal terms
 */
export const useMinuteTrainingPortalAcceptTermsCreate = <TError = ValidationError | UnauthenticatedError | PermissionDeniedError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof minuteTrainingPortalAcceptTermsCreate>>, TError,MinuteTrainingPortalAcceptTermsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof minuteTrainingPortalAcceptTermsCreate>>,
        TError,
        MinuteTrainingPortalAcceptTermsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getMinuteTrainingPortalAcceptTermsCreateMutationOptions(options), queryClient);
    }
